import { Link, useLocation } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="bg-[#F5F5F2] min-h-[70vh] flex items-center">
      <SEO
        title="Page Not Found"
        description="The BitGenix page you requested could not be found."
        path={location.pathname}
        robots="noindex, nofollow"
      />
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <p className="font-body text-sm uppercase tracking-[0.2em] text-[#A7A55C] mb-5">404 Error</p>
        <h1 className="font-heading font-semibold text-4xl sm:text-5xl text-[#21324D] leading-tight mb-6">
          This page does not exist
        </h1>
        <p className="font-body text-base text-[#383A46]/75 leading-relaxed mb-10">
          Try one of the main BitGenix pages below to continue exploring crypto tax, compliance, investment advisory, and blockchain consulting.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="bg-[#A7A55C] text-[#F5F5F2] hover:bg-[#8C8A4A] transition-colors font-body font-semibold text-sm px-8 py-4"
          >
            Go to Homepage
          </Link>
          <Link
            to="/contact"
            className="border border-[#21324D]/15 text-[#21324D] hover:border-[#A7A55C] hover:text-[#A7A55C] transition-colors font-body font-semibold text-sm px-8 py-4"
          >
            Contact BitGenix
          </Link>
        </div>
      </div>
    </div>
  );
}
